export default __webpack_public_path__ + "10f1184d98bd6ae065e79710e9ef5c3a.png";